// extracted by mini-css-extract-plugin
export var darkBorder = "Input-module--darkBorder--7c040";
export var hasIcon = "Input-module--hasIcon--e1445";
export var iconWrapper = "Input-module--iconWrapper--96d3b";
export var input = "Input-module--input--d0b83";
export var small = "Input-module--small--6bf77";
export var wrapper = "Input-module--wrapper--ba19d";